export default {
    count_active: 'Activate your account!',
    days: 'days.',
    expired: 'Your trial period has expired, activate your account!',
    you_have: 'You have ',
    take_session: ' To book your free training session.',
    take_now: ' Book now.',
}